export const DEPRECIATION = {
  initial_used_factor: 0.85,
  age: {
    knee_years: 17,
    knee_power: 1.5,
    knee_value_eur: 800,
    phase1_end_years: 20,
    cliff_power: 2.0,
    transition_value_eur: 500,
    phase2_end_years: 30,
    floor_value_eur: 150,
  },
  jumps: {
    horizon_jumps: 3000,
    power: 0.85,
    estimate_cap: 2200,
    estimate_tau: 10,
  },
  combination: {
    method: 'worse_dominant',
    secondary_weight: 0.3,
  },
};

export const ADJUSTMENTS = {
  brand_premium: {
    'upt': 1.10,
    'sun-path': 1.05,
    _default: 1.0,
  },
  container_size: {
    tiers: [
      { max_above: 220, penalty: 0.87, label: 'very large (>220 sqft)' },
      { max_above: 190, penalty: 0.90, label: 'large (>190 sqft)' },
      { min_below: 80,  penalty: 0.92, label: 'very small (<80 sqft)' },
      { min_below: 100, penalty: 0.95, label: 'small (<100 sqft)' },
    ],
  },
  harness_size: {
    tiers: [
      { height_min: 200, weight_min: 115, penalty: 0.87, label: 'very large frame' },
      { height_min: 195, weight_min: 105, penalty: 0.90, label: 'large frame' },
      { height_min: 190, weight_min: 95,  penalty: 0.95, label: 'above average frame' },
    ],
  },
};

export const MANUFACTURERS = {
  upt: {
    brand_key: 'upt',
    models: {
      'vector':    { new_price_eur: 3437 },
      'mutant':    { new_price_eur: 3437 },
      'vector-se': { new_price_eur: 3002 },
      'micron':    { new_price_eur: 3437 },
    },
  },
  'sun-path': {
    brand_key: 'sun-path',
    models: {
      'javelin-odyssey':  { new_price_eur: 3045 },
      'javelin-accuracy': { new_price_eur: 3045 },
      'javelin-aurora':   { new_price_eur: 3045 },
      'student':          { new_price_eur: 2871 },
    },
  },
  mirage: {
    brand_key: 'mirage',
    models: {
      'g4.3': { new_price_eur: 3219 },
      'g4.2': { new_price_eur: 3045 },
      'g4.1': { new_price_eur: 3045 },
      'g4':   { new_price_eur: 3045 },
      'g3':   { new_price_eur: 2784 },
    },
  },
  aerodyne: {
    brand_key: 'aerodyne',
    models: {
      'icon-v':       { new_price_eur: 3654 },
      'icon-a':       { new_price_eur: 3045 },
      'icon':         { new_price_eur: 3350 },
      'icon-student': { new_price_eur: 3850 },
    },
  },
  paratec: {
    brand_key: 'paratec',
    models: {
      'next-century': { new_price_eur: 4358 },
    },
  },
  'rigging-innovations': {
    brand_key: 'rigging-innovations',
    models: {
      'curv-2.0':        { new_price_eur: 2609 },
      'voodoo-curv-2.0': { new_price_eur: 2522 },
    },
  },
  'sunrise-manufacturing': {
    brand_key: 'sunrise-manufacturing',
    models: {
      'wings-classic': { new_price_eur: 2153 },
      'wings-vision':  { new_price_eur: 2249 },
      'wings':         { new_price_eur: 2153 },
    },
  },
  firebird: {
    brand_key: 'firebird',
    models: {
      'evo-sport':   { new_price_eur: 3479 },
      'evo-student': { new_price_eur: 2958 },
    },
  },
  sws: {
    brand_key: 'sws',
    models: {
      'fire-2':         { new_price_eur: 1653 },
      'fire-2-student': { new_price_eur: 1566 },
      'fire-2-tso':     { new_price_eur: 2088 },
      'fire':           { new_price_eur: 1566 },
      'edge-2':         { new_price_eur: 818 },
    },
  },
  'velocity-sports': {
    brand_key: 'velocity-sports',
    models: {
      'infinity': { new_price_eur: 3306 },
    },
  },
  'parachute-systems': {
    brand_key: 'parachute-systems',
    models: {
      'vortex-ii': { new_price_eur: 2175 },
    },
  },
  'parachutes-de-france': {
    brand_key: 'parachutes-de-france',
    models: {
      'atom-legend': { new_price_eur: 3000 },
      'atom':        { new_price_eur: 2500 },
    },
  },
  basik: {
    brand_key: 'basik',
    models: {
      'advance': { new_price_eur: 2500 },
    },
  },
  'na-aerodynamics': {
    brand_key: 'na-aerodynamics',
    models: {
      'centaurus':         { new_price_eur: 3479 },
      'student-centaurus': { new_price_eur: 4549 },
    },
  },
  pmi: {
    brand_key: 'pmi',
    models: {
      'glide': { new_price_eur: 3218 },
    },
  },
  sife: {
    brand_key: 'sife',
    models: {
      'rt':     { new_price_eur: 3200 },
      'rt-2.0': { new_price_eur: 3200 },
      'ac-2.0': { new_price_eur: 3200 },
    },
  },
  travel: {
    brand_key: 'travel',
    models: {
      'travel': { new_price_eur: 4320 },
    },
  },
};
